import type { PageChangeFn } from '../../../components/Pagination/Pagination';
import type { ListingPagination } from '../../../hooks/api/hook-builders/listing-hook-builder';
import type {
  ContentObject,
  ContentTypeDefinition,
} from '../../flotiq-client/types/api-response';

import { IFlotiqPluginEvent } from './IFlotiqPluginEvent';

type GridAddElementEventInit = {
  /** Content type api name */
  contentTypeName: string;
  /** Content type that includes the field */
  contentType: ContentTypeDefinition;
  /** Content Type Objects for current page */
  contentObjects: ContentObject[];
  /** Pagination returned from API */
  pagination: ListingPagination;
  /** Function to change page */
  handlePageChange: PageChangeFn;
  /** Function to update grid data */
  reload: () => void;
  /** Indicates whether the query is currently being fetched (including background-fetching) */
  isFetching: boolean;
  /** Indicates whether the query is in the process of fetching data for the first time */
  isLoading: boolean;
};

/**
 * An event that is fired when a grid is rendered.
 * Returning anything will embed that result above the grid.
 *
 * @eventName "flotiq.grid::add"
 * @returns {null|string|array|number|boolean|HTMLElement|ReactElement}
 *          Null if rendering should be passed to either Flotiq or other plugins.
 *          Renderable result if plugin wants to place the item above the grid.
 * @memberof FlotiqPlugins.Events
 */
export class GridAddElementEvent extends IFlotiqPluginEvent {
  constructor(initData: GridAddElementEventInit) {
    super(initData);
  }
}
